import React from "react";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { InfoOutlined } from "@mui/icons-material";
import { ApprovalButton, OutlinedButton } from "@/Components/v2/atoms/Button";

type BannerStyle = {
  title: string;
  description: string;
  style: {
    infoIcon: {
      color: string;
    };
  };
};

interface ApproveActionBannerProps {
  onApproveClick: () => void;
  onViewClick: () => void;
  bannerStyle: BannerStyle;
}

const ApproveActionBanner = ({
  onApproveClick,
  onViewClick,
  bannerStyle,
}: ApproveActionBannerProps) => {
  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" mr={6}>
        <Stack direction="row" spacing={1}>
          <InfoOutlined sx={{ ...bannerStyle.style.infoIcon, fontSize: 24 }} />
          <Stack>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              {bannerStyle.title}
            </Typography>
            <Typography variant="body2" maxWidth="900px">
              {bannerStyle.description}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        <OutlinedButton onClick={onViewClick} sx={{ whiteSpace: "nowrap" }}>
          View Action Plan
        </OutlinedButton>

        <ApprovalButton onClick={onApproveClick} sx={{ whiteSpace: "nowrap" }}>
          Mark as Approved
        </ApprovalButton>
      </Stack>
    </>
  );
};

export default ApproveActionBanner;
